const subHeadingsData = {
    1: [
        {
            title: "About Us",
            content: (
                <>
                    <p>
                        lorem34
                    </p>
                </>
            )
        }
    ],
    2: [
        {
            title: "Mission",
            content: (
                <>
                    <p>
                        lorem34
                    </p>
                </>
            )
        }
    ],
    3: [
        {
            title: "Vision",
            content: (
                <>
                    <p>
                        lorem34
                    </p>
                </>
            )
        }
    ]
};

export default subHeadingsData;